const ranking = [
  {
    rank: 1,
    title: '《炎之轨迹》第二季',
    category: '热血战斗',
    heat: '🔥 32.6万',
    change: 'up' as const,
  },
  {
    rank: 2,
    title: '《夏日幻境》',
    category: '奇幻冒险',
    heat: '🔥 28.1万',
    change: 'up' as const,
  },
  {
    rank: 3,
    title: '《恋空物语》',
    category: '恋爱甜宠',
    heat: '🔥 24.9万',
    change: 'same' as const,
  },
  {
    rank: 4,
    title: '《异世界转生录》',
    category: '异世界冒险',
    heat: '🔥 21.3万',
    change: 'up' as const,
  },
  {
    rank: 5,
    title: '《深夜侦探社》',
    category: '悬疑推理',
    heat: '🔥 18.7万',
    change: 'down' as const,
  },
];

function RankBadge({ rank }: { rank: number }) {
  if (rank === 1) return <span className="w-7 h-7 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center text-xs font-bold">1</span>;
  if (rank === 2) return <span className="w-7 h-7 rounded-lg bg-secondary-400 text-background-50 flex items-center justify-center text-xs font-bold">2</span>;
  if (rank === 3) return <span className="w-7 h-7 rounded-lg bg-background-400 text-background-50 flex items-center justify-center text-xs font-bold">3</span>;
  return <span className="w-7 h-7 rounded-lg bg-background-100 text-foreground-600 flex items-center justify-center text-xs font-bold">{rank}</span>;
}

function ChangeIcon({ change }: { change: 'up' | 'down' | 'same' }) {
  if (change === 'up') return <i className="ri-arrow-up-line"></i>;
  if (change === 'down') return <i className="ri-arrow-down-line"></i>;
  return <i className="ri-subtract-line"></i>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-fire-line"></i>
            本周热度榜
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            新番热度榜
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            基于追更动漫热度的实时排名，看看大家最近都在追哪些番
          </p>
        </div>
        <div className="max-w-2xl mx-auto bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden">
          {ranking.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100/50 transition-colors cursor-pointer ${
                i < ranking.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <RankBadge rank={item.rank} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className={`text-xs ${
                    item.change === 'up' ? 'text-green-600' : item.change === 'down' ? 'text-red-500' : 'text-foreground-400'
                  }`}>
                    <ChangeIcon change={item.change} />
                  </span>
                </div>
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>
              <span className="text-xs text-foreground-700 font-medium whitespace-nowrap">{item.heat}</span>
            </a>
          ))}
        </div>
        <div className="text-center mt-6">
          <a
            href="#cards"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium hover:underline cursor-pointer"
          >
            查看完整榜单
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}